import { ButtonTiny } from './ButtonTiny';
import { ProgressBar } from './ProgressBar';
import { ButtonColorVariant } from './ButtonTiny';

interface NavigationBarProps {
    onBack?: () => void;
    onClose?: () => void;
    onMenu?: () => void;
    title?: string;
    titleColor?: string;
    progress?: number;
    currentStep?: number;
    totalSteps?: number;
    rightButton?: React.ReactNode;
    leftButton?: React.ReactNode;
    buttonColorVariant?: ButtonColorVariant;
}

export const NavigationBar = ({ onBack, onClose, onMenu, title, titleColor = "text-white", progress, currentStep, totalSteps, rightButton, leftButton, buttonColorVariant = "gray" }: NavigationBarProps) => {
    return (
        <nav className="flex items-center justify-between w-full safe-pt-2 px-8 max-w-main gap-3">
            <div className="w-8 flex-shrink-0">
                {onBack && <ButtonTiny variant="back" onClick={onBack} colorVariant={buttonColorVariant} />}
                {onMenu && <ButtonTiny variant="menu" onClick={onMenu} colorVariant={buttonColorVariant} />}
                {leftButton && leftButton}
            </div>
            {(progress || currentStep !== undefined) && <div className="w-full"> <ProgressBar progress={progress} currentStep={currentStep} totalSteps={totalSteps} /></div>}
            {title && <h2 className={`text-lg font-semibold ${titleColor}`}>{title}</h2>}
            <div className='w-8 flex-shrink-0'>
                {onClose && <ButtonTiny variant="close" onClick={onClose} colorVariant={buttonColorVariant} />}
                {rightButton && rightButton}
            </div>
        </nav>
    );
}; 